export const TYPE_BANNER = 'B';
export const TYPE_SLIDER = 'S';
